import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=5a5e78cc&"
import script from "./DetailForm.vue?vue&type=script&lang=js&"
export * from "./DetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports